//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import goBack from '@/components/public-components/goBack/index.vue'
import mapList from '@/components/public-components/mapList/index.vue'
import Footer from "@/components/lyx-components/lyx-footer/index"

export default {
    name: 'culture',
    components: {
        goBack,
        mapList,
        Footer
    },
    data() {
        return {
            showMapList: false,
            minHeight: 0,
            mapNav: { title: "123" },
            row: {
                venueEntity: {
                    title: ''
                }
            }
        }    
    },
    watch: {
        '$route': function (to, from) {
            document.title = row.venueEntity.title
        }
    },
    mounted() {
        this.minHeight = document.documentElement.clientHeight
        this.apiRow().then(data => {
            document.title = data.venueEntity.title
            this.row = data
        })
    },
    methods: {
        jump_special(){
            if(this.$route.query.id==='be9327285b464682a96e7fef5563a254'){
                this.$router.push({
                path:'/numSpecial',
            })
            }else if(this.$route.query.id==='71707de9d6d040f1bc449a2b022d45dd'){
                window.open(this.row.venueEntity.vrUrl,'_blank')
            }
          
        },
        apiRow() {
            return new Promise((resolve, reject) => {
                this.$http.get(`api/wtcp-bics/public/venue/findById/${this.$route.query.id}`).then(res => {
                    resolve(res.data.data)
                })
            })
        },
        goPage(path) {
            this.$router.push({path})
        },
        phone(number) {
            window.location.href = 'tel:' + number
        }
    }
}
